/**
 * 阿根廷-PayWay(Venta Online / Decidir) JS SDK 工具
 * SDK: https://ventasonline.payway.com.ar/static/v2.6.4/decidir.js
 * 用法: loadPaywayScript() -> new window.Decidir(getPaywayApiUrl(sandbox)) -> setPublishableKey(publicKey) -> createToken(form, cb)
 * 注意: token 一次性, 每次发起支付(含重试)都要重新 createToken
 */

let paywayScript = null

export function loadPaywayScript() {
  return new Promise((resolve, reject) => {
    if (window.Decidir) {
      resolve()
      return
    }
    if (paywayScript) {
      paywayScript.addEventListener('load', () => resolve())
      paywayScript.addEventListener('error', reject)
      return
    }
    paywayScript = window.document.createElement('script')
    paywayScript.src = 'https://ventasonline.payway.com.ar/static/v2.6.4/decidir.js'
    paywayScript.onload = () => resolve()
    paywayScript.onerror = (e) => reject(e)
    const head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
    head.insertBefore(paywayScript, head.firstChild)
  })
}

export function getPaywayApiUrl(sandbox) {
  // 注意: 旧域名 developers.decidir.com 不响应 OPTIONS 预检,浏览器直连会 CORS 失败
  return sandbox
    ? 'https://developers-ventasonline.payway.com.ar/api/v2'
    : 'https://ventasonline.payway.com.ar/api/v2'
}

/**
 * 按卡号识别 PayWay payment_method_id(官方 Medios de pago ID 表)
 * 仅覆盖常见信用卡; 识别不出返回 null(前端提示不支持的卡)
 */
export function detectPaywayPaymentMethodId(cardNumber) {
  const num = (cardNumber || '').replace(/\s+/g, '')
  if (/^4/.test(num)) return 1 // Visa
  if (/^(5[1-5]|2[2-7])/.test(num)) return 104 // MasterCard Payway
  if (/^3[47]/.test(num)) return 65 // American Express
  if (/^3(0[0-5]|[68])/.test(num)) return 8 // Diners Club
  if (/^589562/.test(num)) return 24 // Tarjeta Naranja
  if (/^(604201|589657|603522)/.test(num)) return 63 // Cabal Payway
  return null
}
